import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import VueAppInsights from 'vue-application-insights';

const VueCookie = require('vue-cookie');
Vue.use(VueCookie);

const moment = require('moment');
require('moment/locale/nb');

Vue.use(VueMoment, { moment });
Vue.use(Vuelidate);

const id = process.env.NODE_ENV === 'development' ? '' : '6be9ce66-8943-4913-885d-4c455d58be1a';
Vue.use(VueAppInsights, {
    id,
    baseName: 'Private Orderflow',
    trackInitialPageView: false,
    router,
});

Vue.config.productionTip = false;

new Vue({
    el: '#orderflow',
    render: h => h(App),
    router,
    store,
});
